export const humanResourcesAccionesRoles = {
  sideNavActions: {
    usersList: undefined,
    competenceList: ['Admin', 'HumanResources', 'QualityControl'],
    matriz: ['Admin', 'HumanResources', 'QualityControl'],
    registerCompetence: undefined,
    validateCompetence: ['Admin', 'HumanResources'],
  },
  routerActions: {
    root: ['Admin', 'HumanResources'],
  },
};
